import partialsLoader from './../partials/loader';
import AOS from 'aos';

//
export default {
  init() {
    // JavaScript to be fired on all pages
    partialsLoader.init();
    AOS.init({
      once: true,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    partialsLoader.finalize();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js